module.exports = __webpack_public_path__ + "img/productService.5a28df8d.jpg";